export class NonceHelper {
  static getNonceValue = (): string => {
    const nonceValueMeta = document.querySelector("meta[name='csp-nonce']");
    const content = nonceValueMeta?.getAttribute("content");
    return content ? content : "";
  };
}
